module.exports = __webpack_public_path__ + "d2b9b298e7b5987812de3039604ca81e.png";